const variables = {
    SystemTitle: "VO Danmark system",
    AppBottomInfo: "VO Danmark",
    ContactMail: "",
    RedeemImage: "https://system.vo-danmark.dk/api/user/picture/Emil",
  cvropslagDisabled: true,
  customerRemindersDisabled: true,
  afregningDisabled: false,
  pointSystemDisabled: true
};

export default variables;
